export default __webpack_public_path__ + "static/media/custom1.e6d7cb6a.jpg";